import Axios from 'axios';

export const arrayToDict = (array, field = 'id') =>
  array.reduce((result, party) => {
    // eslint-disable-next-line no-param-reassign
    result[party[field]] = party;
    return result;
  }, {});

const insularProvinces = [
  '35', // Las Palmas
  '38' // Santa Cruz de Tenerife
];

export const makeRequest = path => {
  if (path && !path.includes('undefined')) {
    if (!window.cacheKey[path] && !window.callStack.includes(path)) {
      window.callStack.push(path);
      return Axios.get(new URL(path))
        .then(response => {
          if (response.data) {
            // setRestData(response.data);
            window.cacheKey[path] = response.data;
            return response.data;
          }
          window.callStack = window.callStack.filter(item => item !== path);
        })
        .catch(() => {
          window.callStack = window.callStack.filter(item => item !== path);
        });
    }
    if (!window.cacheKey[path] && window.callStack.includes(path)) {
      const chekIfDataIsReady = () => {
        if (window.cacheKey[path]) {
          //   setRestData(window.cacheKey[path]);
          return Promise.resolve(window.cacheKey[path]);
        }
        if (window.callStack.includes(path)) {
          return new Promise(resolve => {
            const interval = setInterval(() => {
              if (window.cacheKey[path]) {
                //   setRestData(window.cacheKey[path]);
                clearInterval(interval);
                resolve(window.cacheKey[path]);
              }
            }, 200);
          });
        }
      };
      return chekIfDataIsReady();
    }
    // setRestData(window.cacheKey[path]);
    return Promise.resolve(window.cacheKey[path]);
  }
  return Promise.resolve([]);
};

export const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

export const isInsular = province => insularProvinces.includes(province);

export * from './hooks';
